/* umbra-cls-reserve.js (product pages only, 2026-09-30, layout shift while scrolling)

   Two small helpers, theme code only (nothing of Bazaarvoice's own scripts is touched):

   1. window.umbraShrink(el, apply, keep)
      Runs apply(), a change that makes el smaller (to keep px high, 0 when it goes away), without moving what the
      visitor is looking at. A shift counts when something on screen moves, or when something moves on to the screen.
      - el is entirely below the screen and what follows it would still be below the screen afterwards
        (el top + keep >= screen height): apply() straight away.
      - el is entirely above the screen: apply(), then scroll by exactly the distance the page content moved, in the same
        frame, so the visitor keeps looking at the same thing.
      - otherwise (el on screen, or what follows would slide on to the screen): wait, and look again on scroll and resize.

   2. The reviews box (2026-10-05, BV-DESIGN; wave 5: the reveal waits until Bazaarvoice is quiet). The Bazaarvoice reviews widget
      (the element carrying data-bv-show="reviews") mounts many seconds after the page has loaded, grows from 0 to 3,000 to 6,000 px
      in steps and rebuilds its list in place. Its box (.umbra-rv-box, rendered by sections/apps.liquid) has a fixed height from the
      first frame (assets/umbra-pdp-editorial.css), so nothing outside it can move; an opaque skeleton covers it, and while the
      skeleton is there the widget behind it is visibility:hidden (CSS), so what it draws and rebuilds there scores no layout shift.
      This script (a) starts Bazaarvoice earlier (see "earlier start"), (b) removes the skeleton once reviews exist and Bazaarvoice
      has been quiet for QUIET_MS (no request in flight, none answered and nothing changed in its tree for that long; 12 s after the
      first review at the latest): that is the reveal, and nothing moves, (c) then switches the box from fixed to natural height
      exactly once, only while its bottom edge is well below the screen before and after the change (or, with only what is below
      the reviews on screen, with the page scrolled by the change in the same frame), (d) gives the box the short size
      (1,100 px) when no Bazaarvoice request has started 5 s after this script started, and the full size again when one starts later, and
      (e) lets the box go (natural height, no skeleton) when the visitor has refused and the Bazaarvoice loader is really absent
      (see "consent"). The box itself is never hidden or faded.

   3. A frame-by-frame guard (follow; repair round 2026-10-05): a few elements on screen are followed; if one moves by something other than the
      visitor's scrolling (something was added or removed above it), the page is scrolled by the same amount before the
      frame is painted. Chrome's own scroll anchoring does this too but stands down whenever the style of a parent changes in
      the same frame, which the reviews widget does while it draws. For the reviews box the guard runs whenever the box is not
      entirely below the screen, also after the box has switched to natural height (Bazaarvoice rebuilds its list in place, and a
      photo strip is drawn above the box when the visitor comes near), it is also run straight from the widget's MutationObserver
      (same task as the change), and where the skeleton still covers the box, the box itself is the mark (until the skeleton goes). A tall
      element whose top stays put while its content moves (Bazaarvoice's own container) is a mark only when nothing else is on screen,
      and when the marks disagree (something drawn in the middle of the screen, such as Bazaarvoice's "most helpful" cards or photo strip
      arriving when the visitor reaches them), the part that covers more of the screen is kept still; when every mark has gone
      (Bazaarvoice replaced what they were in), the reviews on screen, found again by id, are the reference. It hides nothing. */
(function () {
  'use strict';

  function anchorNode() {
    var x = Math.round(window.innerWidth / 2);
    var y = Math.round(window.innerHeight / 2);
    var n = document.elementFromPoint(x, y);
    if (n && (n === document.documentElement || n === document.body)) n = null;
    return n;
  }

  function umbraShrink(el, apply, keep) {
    keep = keep || 0;
    var done = false;
    function attempt() {
      if (done) return;
      if (!el.isConnected) { done = true; cleanup(); apply(); return; }
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (r.height === 0 || (r.top >= vh && r.top + keep >= vh)) {
        done = true; cleanup(); apply(); return;
      }
      if (r.bottom <= 0) {
        done = true; cleanup();
        var a = anchorNode();
        var before = a ? a.getBoundingClientRect().top : 0;
        apply();
        if (a && a.isConnected) {
          var d = a.getBoundingClientRect().top - before;
          if (Math.abs(d) >= 1) window.scrollBy({ top: d, left: 0, behavior: 'instant' });
        }
        if (window.umbraRebase) window.umbraRebase();
      }
    }
    var ticking = false;
    function onMove() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; attempt(); });
    }
    function cleanup() {
      window.removeEventListener('scroll', onMove);
      window.removeEventListener('resize', onMove);
    }
    window.addEventListener('scroll', onMove, { passive: true });
    window.addEventListener('resize', onMove, { passive: true });
    attempt();
  }
  window.umbraShrink = umbraShrink;
  /* BV-DIAG (2026-10-29): Bazaarvoice draws "Customer Images and Videos" as an empty placeholder (431 px + an empty 108 px div at 393)
     and swaps in the 221 px strip once the placeholder is 25% on screen (its own IntersectionObserver); filters and reviews then rise
     318 px in view (CLS 0.23 on bellwood-desk-frame). Observers of an empty div of the reviews widget outside its review list look two
     screens ahead instead, so the swap is done off screen. Hides nothing; review cards and photo tiles keep Bazaarvoice's own observer. */
  (function () {
    var NIO = window.IntersectionObserver;
    if (!NIO || NIO.__umbraBv) return;
    var P = NIO.prototype, nObs = P.observe, nUnobs = P.unobserve, nDisc = P.disconnect;
    function lazyBv(t) {
      try {
        var h = t.getRootNode().host;
        return !!h && h.matches('[data-bv-show="reviews"]') && t.tagName === 'DIV' && !t.closest('#reviews_container, [id^="bv-review-"], .photos-tile') &&
          !(t.textContent || '').trim() && !t.querySelector('img, video, button, a, input');
      } catch (e) { return false; }
    }
    function W(cb, opts) { var io = Reflect.construct(NIO, [cb, opts], new.target || W); try { Object.defineProperty(io, '__umbraCb', { value: cb }); } catch (e) {} return io; }
    W.prototype = P; W.__umbraBv = true;
    P.observe = function (t) {
      if (!this.__umbraCb || this.root != null || !lazyBv(t)) return nObs.apply(this, arguments);
      var self = this, cb = this.__umbraCb, px = new NIO(function (es) { cb.call(self, es, self); }, { rootMargin: '200% 0px 200% 0px', threshold: this.thresholds });
      (this.__umbraPx || (this.__umbraPx = [])).push({ t: t, px: px });
      return nObs.call(px, t);
    };
    P.unobserve = function (t) { var l = this.__umbraPx || []; for (var i = l.length - 1; i >= 0; i--) if (l[i].t === t) { nDisc.call(l[i].px); l.splice(i, 1); } return nUnobs.apply(this, arguments); };
    P.disconnect = function () { var l = this.__umbraPx || []; while (l.length) nDisc.call(l.pop().px); return nDisc.apply(this, arguments); };
    window.IntersectionObserver = W;
  })();


  /* ---- keep the view steady (scroll anchoring that does not give up) ----
     Chrome's own scroll anchoring stands down whenever the style of the element it follows, or of a parent, changes in
     the same frame, and the reviews widget does exactly that while it draws. Here: a few elements that are on screen are
     followed frame by frame; if one of them has moved on the page by something other than the visitor's own scrolling
     (something was added or removed above it), the page is scrolled by the same amount in the same frame, before it is
     painted, so the visitor keeps looking at the same thing and no shift is recorded. It only acts when something moved. */
  var FOLLOW_MS = 300000;
  var fStart = Date.now();
  var marks = [];
  var lastSy = 0;
  var fixes = [];
  var stopped = false;
  var fRunning = false;   // the frame loop below is running
  var followHosts = [];   // one entry per reviews box: { ended, below } (below: the box is entirely below the screen)
  var followIO = null;

  /* The loop only has a job while a reviews box is not entirely below the screen: while it is, the box growing (the widget
     draws from 0 to 6,000 px) cannot move anything that is on screen. It stops when every box has ended. */
  function followWanted() {
    for (var i = 0; i < followHosts.length; i++) if (!followHosts[i].ended && !followHosts[i].below) return true;
    return false;
  }
  function observeFollow(host, entry) {
    if (!('IntersectionObserver' in window)) { startFollow(); return; }
    if (!followIO) {
      followIO = new IntersectionObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var e = list[i], en = e.target.__umbraFollow;
          if (!en) continue;
          en.below = !e.isIntersecting && !!e.rootBounds && e.boundingClientRect.top >= e.rootBounds.bottom;
          if (!en.below) startFollow();
        }
      }, { rootMargin: '0px 0px 100% 0px' });   // the loop is running a screen ahead: what is drawn above the box when the visitor comes near (a photo strip) starts at about that moment
    }
    host.__umbraFollow = entry;
    followIO.observe(host);
  }

  function deepFromPoint(x, y) {
    var n = document.elementFromPoint(x, y);
    var guard = 0;
    while (n && n.shadowRoot && guard++ < 6) {
      var m = n.shadowRoot.elementFromPoint(x, y);
      if (!m || m === n) break;
      n = m;
    }
    return n;
  }
  /* not a good mark: fixed or sticky (does not move with the page), or moving or animated by itself (sliders, banners) */
  function unsteady(n) {
    for (var e = n, i = 0; e && e.nodeType === 1 && i < 60; i++) {
      var cs = getComputedStyle(e);
      if (cs.position === 'fixed' || cs.position === 'sticky') return true;
      if (cs.transform !== 'none' || (e.getAnimations && e.getAnimations().length)) return true;
      e = e.parentElement || (e.getRootNode && e.getRootNode().host) || null;
    }
    return false;
  }
  /* what the visitor sees where the skeleton still covers the reviews box is the skeleton, not Bazaarvoice's own (hidden) drawing
     behind it: the box itself is the mark there, so what moves inside Bazaarvoice behind the skeleton never moves the page */
  function skeletonBox(n) {
    for (var e = n, i = 0; e && e.nodeType === 1 && i < 80; i++) {
      if (e.classList && e.classList.contains('umbra-rv-box')) return e.querySelector('[data-umbra-rv-skel]') ? e : null;
      e = e.parentElement || (e.getRootNode && e.getRootNode().host) || null;
    }
    return null;
  }
  function pickMarks() {
    var vh = window.innerHeight, vw = window.innerWidth;
    var out = [];
    var fr = [0.22, 0.5, 0.78], fx = [0.5, 0.3, 0.7];
    for (var i = 0; i < fr.length; i++) {
      var best = null;
      for (var j = 0; j < fx.length && !(best && !best.weak); j++) {
        var n = deepFromPoint(Math.round(vw * fx[j]), Math.round(vh * fr[i]));
        if (!n || n === document.documentElement || n === document.body) continue;
        var sk = skeletonBox(n);
        if (sk) n = sk;
        if (unsteady(n)) continue;
        var br = n.getBoundingClientRect();
        /* a mark taller than the screen is judged by whether it is still on screen, not by where its top is. The skeleton's box is a good
           one (the visitor sees the skeleton there); any other is weak: its top stays put when something inside it moves (2026-10-05:
           Bazaarvoice's own container was the mark, so the guard missed the "most helpful" cards and the photo strip moving the reviews) */
        var tall = br.height > vh * 1.5;
        var c = { el: n, top: br.top, tall: tall, sk: !!sk, weak: tall && !sk };
        if (!best || (best.weak && !c.weak)) best = c;
      }
      if (best) out.push(best);
    }
    return out;
  }
  /* the marks disagree: something changed between them. Keep still the part that covers more of the screen: each mark stands for the
     screen from half way to the mark above it to half way to the one below it. Equal parts: the upper one, as before */
  function pickDiff(ok, vh) {
    if (ok.length === 1) return ok[0].d;
    ok.sort(function (a, b) { return a.y - b.y; });
    var y = function (k) { return Math.max(0, Math.min(vh, ok[k].y)); };
    var best = ok[0].d, bestSpan = -1;
    for (var i = 0; i < ok.length; i++) {
      var span = 0;
      for (var k = 0; k < ok.length; k++) {
        if (Math.abs(ok[k].d - ok[i].d) >= 1) continue;
        span += (k === ok.length - 1 ? vh : (y(k) + y(k + 1)) / 2) - (k === 0 ? 0 : (y(k - 1) + y(k)) / 2);
      }
      if (span > bestSpan) { bestSpan = span; best = ok[i].d; }
    }
    return best;
  }
  /* the reviews on screen by id (Bazaarvoice draws each as section#bv-review-<id> and keeps the id when it redraws it). They are the
     reference when every sampled mark has gone because Bazaarvoice replaced what they were in (2026-10-05, WebKit: its "most helpful"
     placeholder filled the screen and the first review, at the bottom edge, moved 410 px) */
  var rvSeen = null;
  function reviewTops(vh, ids) {   // ids: the reviews to find wherever they are now; without: the reviews on screen
    var out = null, hosts = document.querySelectorAll('[data-bv-show="reviews"]');
    for (var h = 0; h < hosts.length; h++) {
      var sr = hosts[h].shadowRoot;
      if (!sr) continue;
      var list = sr.querySelectorAll('[id^="bv-review-"]');
      for (var i = 0; i < list.length; i++) {
        var r = list[i].getBoundingClientRect();
        if (r.height > 0 && (ids ? ids.hasOwnProperty(list[i].id) : r.bottom > 0 && r.top < vh)) { out = out || {}; out[list[i].id] = r.top; }
      }
    }
    return out;
  }
  function follow() {
    if (stopped || Date.now() - fStart > FOLLOW_MS) { fRunning = false; return; }
    if (!followWanted()) { fRunning = false; return; }
    requestAnimationFrame(follow);
    if (document.hidden) return;
    followStep();
  }
  /* One comparison: has a followed element moved by something other than the visitor's scrolling? Run once a frame (follow) and,
     while the loop is running, straight from the MutationObserver of the reviews widget, so a change Bazaarvoice makes in
     one task is compensated before the frame that would show it is painted. */
  function followStep() {
    if (stopped) return;
    /* P1: the stars jump holds the "Reviews" heading still; the guard must not fight it nor count its scrolls */
    if (pinOn) { lastSy = window.scrollY; marks = pickMarks(); rvSeen = reviewTops(window.innerHeight); return; }
    var sy = window.scrollY;
    var dy = sy - lastSy;
    var vh = window.innerHeight;
    var need = marks.length === 0;
    var diff = 0, have = false, ok = [], weak = null;
    for (var i = 0; i < marks.length; i++) {
      var m = marks[i];
      if (!m.el.isConnected) { need = true; continue; }
      if (m.sk && !m.el.querySelector('[data-umbra-rv-skel]')) { need = true; continue; }   // the reveal: Bazaarvoice itself is on screen now
      var mr = m.el.getBoundingClientRect();
      var t = mr.top;
      if (m.tall ? (mr.bottom < 0 || t > vh) : (t < -200 || t > vh + 200)) { need = true; continue; }
      if (m.weak) { if (weak === null) weak = t - (m.top - dy); need = true; continue; }
      ok.push({ d: t - (m.top - dy), y: m.top - dy });
    }
    if (!ok.length && rvSeen) {
      var rv = reviewTops(vh, rvSeen);
      if (rv) for (var id in rv) ok.push({ d: rv[id] - (rvSeen[id] - dy), y: rvSeen[id] - dy });
    }
    if (ok.length) { diff = pickDiff(ok, vh); have = true; }
    else if (weak !== null) { diff = weak; have = true; }
    if (have && Math.abs(diff) >= 1 && Math.abs(diff) < 30000) {
      var now = Date.now();
      fixes.push(now);
      while (fixes.length && now - fixes[0] > 3000) fixes.shift();
      /* safety: something that keeps moving by itself must not make the page creep */
      if (fixes.length > 12) { stopped = true; return; }
      window.scrollBy({ top: diff, left: 0, behavior: 'instant' });
      need = true;
    }
    lastSy = window.scrollY;
    if (need || !have) marks = pickMarks();
    else for (var k = 0; k < marks.length; k++) marks[k].top = marks[k].el.getBoundingClientRect().top;
    rvSeen = reviewTops(vh);
  }
  /* a scroll made on purpose by umbraShrink is not movement of the page: start the comparison again from here */
  window.umbraRebase = function () {
    lastSy = window.scrollY;
    marks = pickMarks();
    rvSeen = reviewTops(window.innerHeight);
  };
  function startFollow() {
    if (fRunning || stopped || Date.now() - fStart > FOLLOW_MS) return;
    fRunning = true;
    lastSy = window.scrollY;
    marks = pickMarks();
    rvSeen = reviewTops(window.innerHeight);
    requestAnimationFrame(follow);
  }

  /* ---- P1 (2026-10-29, board 4 k-fx51): the stars jump lands with "Reviews" 8 px under what is sticky ----
     A click on the stars (Bazaarvoice's rating summary) makes Bazaarvoice scroll to its reviews (its own smooth scrollIntoView, then a
     second one on #bv_review_maincontainer). Here, before its handler runs (capture on document): scroll-padding-top so both land with
     the heading 8 px under the header (and under the sticky add-to-cart bar from 770 up, where it sits at the top), then, for at most
     4 s, the heading is held there while the widget keeps drawing, once Bazaarvoice's scroll has come to rest (no smooth scroll of our
     own). Any wheel, touch, key or pointer press by the visitor releases it at once. Nothing is hidden or held back. */
  var PIN_MS = 4000, PIN_GAP = 8;
  var pinOn = false;
  function rvParts() {
    var host = document.querySelector('[data-bv-show="reviews"]');
    if (!host) return null;
    var root = host.shadowRoot || host;
    var main = root.querySelector('#bv_review_maincontainer');
    var h2 = null, hs = root.querySelectorAll('h2');
    for (var i = 0; i < hs.length; i++) if (hs[i].getBoundingClientRect().height > 0) { h2 = hs[i]; break; }
    return { host: host, main: main, h2: h2, box: host.closest('.umbra-rv-box') };
  }
  var barH = 0;   // the bar is display:none at the very top of the page (c-top-0): its last measured height stands in
  function pinCover() {
    var cover = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-end')) || 0;
    if (window.matchMedia('(min-width: 770px)').matches) {
      var bar = document.querySelector('sticky-atc-panel');
      if (bar && getComputedStyle(bar).display !== 'none' && bar.offsetHeight > 0) barH = bar.offsetHeight;
      if (bar && barH) cover += barH;
    }
    return cover;
  }
  document.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [];
    var hit = false;
    for (var i = 0; i < path.length; i++) if (path[i].nodeType === 1 && path[i].matches('[data-bv-show="rating_summary"]')) { hit = true; break; }
    if (!hit) return;
    var p = rvParts();
    var cover = pinCover();
    var delta = p && p.main && p.h2 ? p.h2.getBoundingClientRect().top - p.main.getBoundingClientRect().top : 0;
    var de = document.documentElement;
    de.style.scrollPaddingTop = Math.max(0, Math.round(cover + PIN_GAP - delta)) + 'px';
    var ends = 0, padT = 0;
    function unpad() { window.removeEventListener('scrollend', onEnd); clearTimeout(padT); de.style.scrollPaddingTop = ''; }
    function onEnd() { if (++ends >= 2) unpad(); }
    window.addEventListener('scrollend', onEnd);
    padT = setTimeout(unpad, 2000);
    if (!p) return;
    var t0 = Date.now(), lastY = window.scrollY, still = 0, moved = false, settled = false;
    var stops = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
    function release() {
      if (!pinOn) return;
      pinOn = false;
      for (var s = 0; s < stops.length; s++) window.removeEventListener(stops[s], release, true);
      if (window.umbraRebase) window.umbraRebase();
    }
    pinOn = true;
    for (var s = 0; s < stops.length; s++) window.addEventListener(stops[s], release, { capture: true, passive: true });
    function hold() {
      if (!pinOn) return;
      if (Date.now() - t0 > PIN_MS) { release(); return; }
      requestAnimationFrame(hold);
      var y = window.scrollY;
      if (y !== lastY) moved = true;
      still = y === lastY ? still + 1 : 0;
      lastY = y;
      /* R5-P1: the hold starts the first frame the heading reaches its line (cover + 8), even while Bazaarvoice is still
         scrolling, so it is never painted under the bar; otherwise it waits once for Bazaarvoice's scroll to start and
         rest. After that every frame is held. */
      var q = rvParts();
      var el = q && (q.h2 || q.box);
      var diff = el ? el.getBoundingClientRect().top - (pinCover() + PIN_GAP) : 0;
      if (!settled && !(el && diff <= 0) && (still < 3 || (!moved && Date.now() - t0 < 400))) return;
      settled = true;
      if (!el) return;
      if (Math.abs(diff) >= 1) { window.scrollBy({ top: diff, left: 0, behavior: 'instant' }); lastY = window.scrollY; }
    }
    requestAnimationFrame(hold);
  }, true);

  /* ---- reviews box (2026-10-05, BV-DESIGN: fixed box, skeleton, earlier start, one switch to natural height) ----
     The box (.umbra-rv-box, sections/apps.liquid) carries data-umbra-rv-box = fixed | short | natural (assets/umbra-pdp-editorial.css).
     Nothing here hides or fades anything: the box and the Bazaarvoice container are never touched except for that attribute. */
  var EARLY_AT_DCL = false;   // true: also start Bazaarvoice as soon as the page has been parsed (the design's first trigger), see "earlier start"
  var BV_WAIT_MS = 5000;      // no Bazaarvoice request this long after this script started: blocked or absent
  var QUIET_MS = 1500;        // the reveal: reviews exist and Bazaarvoice has been quiet this long (no request in flight or answered, no change in its tree)
  var NOREV_QUIET_MS = 2500;  // a product without reviews: the widget ends as a short invitation
  var NODES_MAX_MS = 12000;   // at the latest this long after the first review exists
  var NODES_NEVER_MS = 25000; // Bazaarvoice has started, no review exists and it has been silent this long: release the box
  var T0 = Date.now();        // R3 (2026-10-15): BV_WAIT_MS counts from here, not from the load event (it may never come: UK's proxied bv.js)
  var loaded = document.readyState === 'complete';
  var loadAt = loaded ? Date.now() : 0;   // the load event: where Shopify's script-tag loader (the app's own Bazaarvoice tag) starts
  var hostGates = [];         // called the moment a Bazaarvoice request starts

  /* Bazaarvoice requests in flight, counted by watching (not changing) fetch and XMLHttpRequest. */
  var bvInflight = 0;
  var bvSeen = false;     // any request to Bazaarvoice has started (its loader, its apps, its data)
  var bvFirstAt = 0;
  var bvLastEnd = 0;
  var bvLastAct = 0;      // the last time any Bazaarvoice request started or ended
  function isBv(url) { return typeof url === 'string' && /bazaarvoice\.com\/(bfd|api)\//.test(url); }
  function bvNote() { bvLastAct = Date.now(); if (!bvSeen) { bvSeen = true; bvFirstAt = bvLastAct; for (var g = 0; g < hostGates.length; g++) hostGates[g](); } }
  function bvStart() { bvInflight++; bvNote(); }
  function bvEnd() { if (bvInflight > 0) bvInflight--; bvLastEnd = Date.now(); bvLastAct = bvLastEnd; }
  /* its loader and apps are plain script requests, seen through resource timing (they are in the list once they have arrived); the
     data requests are seen through fetch and XMLHttpRequest below. On a slow phone the apps arrive many seconds before the data.
     Only an answered request counts: a request that was blocked or failed also leaves an entry (status 0, no bytes), and counting
     it would keep a blocked widget from ever being recognised as blocked. */
  function bvAnswered(e) {
    var st = e.responseStatus;
    if (typeof st === 'number') return st >= 200 && st < 400;
    return e.transferSize > 0 || e.decodedBodySize > 0 || e.encodedBodySize > 0 || e.transferSize === undefined;   // engines without a status: a size says it was answered
  }
  try {
    if (window.PerformanceObserver) new PerformanceObserver(function (l) {
      var es = l.getEntries();
      for (var i = 0; i < es.length; i++) if (/bazaarvoice\.com/.test(es[i].name) && bvAnswered(es[i])) { bvNote(); break; }
    }).observe({ type: 'resource', buffered: true });
  } catch (e) { /* the fetch and XMLHttpRequest hooks still count */ }
  try {
    var nativeFetch = window.fetch;
    if (nativeFetch) {
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (!isBv(url)) return nativeFetch.apply(this, arguments);
        bvStart();
        var pr = nativeFetch.apply(this, arguments);
        pr.then(bvEnd, bvEnd);
        return pr;
      };
    }
    var xhrOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (isBv(String(url))) {
        var counted = false;
        this.addEventListener('loadstart', function () { if (!counted) { counted = true; bvStart(); } });
        this.addEventListener('loadend', function () { if (counted) { counted = false; bvEnd(); } });
      }
      return xhrOpen.apply(this, arguments);
    };
  } catch (e) { /* observing only: if it cannot be done, the time rules below still apply */ }

  /* ---- earlier start ----
     Shopify's script-tag loader is an inline script (a urls array run by asyncLoad at the load event, 4 to 38 s into the page).
     asyncLoad is NOT called here (it would load every app early and twice). The Bazaarvoice bv.js URL is read from that inline
     script and a script element with the very same URL is added when the reviews box comes within two screens of the viewport
     (IntersectionObserver, rootMargin 200%). The design's other trigger, DOMContentLoaded, is off (EARLY_AT_DCL): measured against
     live it put the median LCP over the 200 ms limit of the brief (the control runs show the cause is other content of the
     theme, not this script, see RESULT.md), so the binding rule moved it to the near-viewport trigger. Set EARLY_AT_DCL to true to
     turn it on: it starts Bazaarvoice's work (about 60 requests) inside the page load, moves the load event 3 s (laptop) to 5 s
     (4x phone) later and brings the reviews 5 to 6 s earlier on a laptop. The app's own tag is left alone. If the page has no
     such URL, nothing happens.
     Consent: the cookie banner (Pandectes) swaps the src of a script it must hold back for type javascript/blocked and keeps
     the element for later; such an element is never added to the page, so Bazaarvoice loads in exactly the states where the
     app's own tag would load it (only earlier). While it is held back this retries every 500 ms until the load event. */
  var early = { done: false, url: null, timer: 0, t0: 0, injectedAt: 0, loadedAt: 0, failed: false };
  function bvLoaderUrl() {
    var list = document.scripts;
    for (var i = 0; i < list.length; i++) {
      var sc = list[i];
      if (sc.src) continue;
      var t = sc.text;
      if (!t || t.length > 20000 || t.indexOf('bv.js') < 0 || t.indexOf('bazaarvoice') < 0) continue;
      var m = t.match(/var urls = (\[[^\]]*\])/);
      if (!m) continue;
      try {
        var arr = JSON.parse(m[1]);
        for (var k = 0; k < arr.length; k++) if (/bazaarvoice\.com/.test(arr[k]) && /\/bv\.js/.test(arr[k])) return String(arr[k]);
      } catch (e) { /* not the loader */ }
    }
    return null;
  }
  function bvScriptPresent() {
    var list = document.scripts;
    for (var i = 0; i < list.length; i++) if (list[i].src && /bazaarvoice\.com/.test(list[i].src) && /\/bv\.js/.test(list[i].src)) return true;
    return false;
  }
  function earlyInject() {   // true when finished (injected or nothing to do), false when held back for now
    try {
      if (early.done || loaded) { early.done = true; return true; }
      if (early.url === null) early.url = bvLoaderUrl() || '';
      if (!early.url || window.BV || bvScriptPresent()) { early.done = true; return true; }
      var s = document.createElement('script');
      s.async = true;
      s.src = early.url;
      if (s.type === 'javascript/blocked') return false;
      s.onload = function () { early.loadedAt = Date.now(); };
      s.onerror = function () { early.failed = true; };   // blocked or unreachable: treated as blocked, not as still on its way
      (document.head || document.documentElement).appendChild(s);
      early.injectedAt = Date.now();
      early.done = true;
      return true;
    } catch (e) { early.done = true; return true; }
  }
  /* the cookie banner has an answer stored (the _pandectes_gdpr cookie, preferences = the blocked categories, 1 = functionality, which
     holds Bazaarvoice back) and it says no: there is no point in waiting for the banner to start up (see "consent" for the box) */
  function consentRefused() {
    try {
      var m = document.cookie.match(/(?:^|; )_pandectes_gdpr=([^;]*)/);
      if (!m) return false;
      var j = JSON.parse(window.atob(m[1]));
      return !!j && typeof j.preferences === 'number' && (j.preferences & 1) !== 0;
    } catch (e) { return false; }
  }
  /* consent (wave 5; R3 2026-10-15): Bazaarvoice is in the banner's functionality category (bit 1). A refusal (stored, consentRefused,
     or the visitor's Decline) does not let the box go by itself: when the banner does not hold Bazaarvoice back, it draws its reviews
     into the box as usual. The box goes only once the loader is really absent: our bv.js held by the banner or failed, or no bv.js has
     run GONE_MS after the load event (Shopify's tag). Pandectes' events: PandectesConsentUpdateLegacy (detail.preferences = the refused
     bits) and PandectesConsentUpdate (detail.preferences false = refused); the older build on the UK and EU stores sends
     PandectesEvent_OnConsent (refused bits). An unanswered banner or a blocker keeps the timeouts as the fallback. */
  var GONE_MS = 10000, declined = false;
  function refused() { return declined || consentRefused(); }
  function loaderGone(now) { return !window.BV && !early.loadedAt && (early.failed || !!early.timer || (loaded && now - loadAt >= GONE_MS)); }
  function wake() { var list = boxes.slice(); for (var i = 0; i < list.length; i++) if (list[i].__umbraRvGo) list[i].__umbraRvGo(); }
  function onConsent(e) {
    var p = e && e.detail ? e.detail.preferences : null;
    if (typeof p === 'number' ? (p & 1) === 0 : p !== false) return;
    declined = true;
    wake();
  }
  window.addEventListener('PandectesConsentUpdate', onConsent);
  window.addEventListener('PandectesConsentUpdateLegacy', onConsent);
  window.addEventListener('PandectesEvent_OnConsent', onConsent);
  function earlyTrigger() {
    if (early.done || early.timer) return;
    if (!early.t0) early.t0 = Date.now();
    if (earlyInject()) return;
    early.timer = setInterval(function () {
      if (earlyInject() || Date.now() - early.t0 > 60000) { clearInterval(early.timer); early.timer = 0; early.done = true; }
    }, 500);
    wake();   // R15d: our bv.js is held by the banner: a refusing visitor's box can go now (loaderGone), not only GONE_MS after the load event
  }
  window.addEventListener('load', function () { loaded = true; loadAt = Date.now(); setTimeout(wake, GONE_MS + 100); });

  function contentHeight(host) {
    var root = host.shadowRoot;
    var kids = root ? root.children : host.children;
    var h = 0;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].nodeName === 'STYLE' || kids[i].nodeName === 'SCRIPT') continue;
      h += kids[i].getBoundingClientRect().height;
    }
    return Math.round(h);
  }

  function starsShown() {
    var s = document.querySelector('.product-main [data-bv-show="rating_summary"], .product-info [data-bv-show="rating_summary"]');
    if (!s) return null;
    return !!s.querySelector('svg');
  }

  var REVIEW_SEL = '[id^="bv-review-"]';
  var boxes = [];
  var nearIO = null;

  function watchBox(box) {
    if (box.__umbraRv) return;
    var host = box.querySelector('[data-bv-show="reviews"]');
    if (!host) return;
    box.__umbraRv = true;
    var skel = box.querySelector('[data-umbra-rv-skel]');
    var end = box.querySelector('[data-umbra-rv-end]');
    var state = box.getAttribute('data-umbra-rv-box') || 'fixed';
    var knownNoRev = document.documentElement.classList.contains('umbra-norev');   // from the first frame (snippets/umbra-norev-ids.liquid)
    var want = null;         // the state to move to at the next moment the change is invisible (bottom edge of the box below the screen before and after)
    var root = null, mo = null;
    var nodes = 0, firstNodeAt = 0, lastMut = Date.now();
    var noRevSince = 0, noRev = false;
    var timer = 0, evalTimer = 0, listening = false, ticking = false, io = null;
    var followEntry = { ended: false, below: false };   // the frame-by-frame guard (follow) runs while the box is not entirely below the screen

    function setState(s) { state = s; box.setAttribute('data-umbra-rv-box', s); }
    function removeSkel() { if (skel) { if (skel.parentNode) skel.parentNode.removeChild(skel); skel = null; } }
    if (knownNoRev) { setState('short'); removeSkel(); }

    /* The height the box will have in a state: its own for fixed (the tier value) and short, the height of the app block for natural. */
    function heightIn(to) {
      if (to === 'short') return 1100;
      if (to === 'fixed') { var v = parseFloat(getComputedStyle(box).getPropertyValue('--umbra-rv-h')); return v > 0 ? v : 0; }
      var app = host.closest('.shopify-app-block') || host;
      return app.getBoundingClientRect().height;
    }
    /* How a change can be made without anything on screen moving:
       'below' = invisible: the bottom edge of the box is at least half a screen below the screen before AND after the change (growing
       moves what follows the box down, shrinking pulls it up: either way it must stay off the screen, and a fast scroll goes on
       moving after the check), or the whole box is that far below the screen;
       'above' = the whole box is above the screen, or what is left of it on screen is only the empty part below the last review
       (a visitor at the end of the page, 87 px of the box's bottom edge in view): what follows the box moves by the change, so the
       page is scrolled by exactly that distance in the same frame (compensated, the same as umbraShrink does) and the visitor keeps
       looking at the same thing;
       '' = not now (the visitor is in the box with reviews in view, or at its bottom edge). */
    function safeFor(to) {
      if (!box.isConnected) return 'below';
      var r = box.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (r.height === 0) return 'below';
      /* R38 (2026-10-18): a box that ends without reviews (Bazaarvoice drew only its invitation) changes only while all of it is at
         least half a screen below the screen. Right after the switch Bazaarvoice draws the invitation again, smaller (US 679 to 248 px),
         a second drop that no scroll compensation can follow, so what comes after the box (register strip, footer) must stay off the
         screen through both. Elsewhere the switch waits: the short box only leaves empty room under the invitation. */
      if (to === 'natural' && !nodes && root) return r.top > vh * 1.5 ? 'below' : '';
      if (Math.min(r.bottom, r.top + heightIn(to)) > vh * 1.5) return 'below';
      /* R3: a shrink here needs at least as much page below the screen, or the browser clamps the scroll (a visitor parked at the page
         end; Chrome scored 0.96): not now. The box and the page end both out of view */
      if (r.bottom <= 0 || contentAbove()) return r.height - heightIn(to) > document.documentElement.scrollHeight - window.scrollY - vh ? '' : 'above';
      return '';
    }
    /* the reviews (the skeleton is gone) are entirely above the screen: only the empty part under them is in view */
    function contentAbove() {
      if (skel || !host.shadowRoot) return false;
      var kids = host.shadowRoot.children, bottom = -1e9;
      for (var i = 0; i < kids.length; i++) {
        if (kids[i].nodeName === 'STYLE' || kids[i].nodeName === 'SCRIPT') continue;
        var kr = kids[i].getBoundingClientRect();
        if (kr.height > 0 && kr.bottom > bottom) bottom = kr.bottom;
      }
      return bottom > -1e9 && bottom <= 0;
    }
    /* make fn() (a change of the box's size) and put the page back where the visitor was. It is used only when what is on screen
       is all below the reviews (the box above the screen, or only its empty tail in view), so all of it moves exactly as far as the
       box's bottom edge: the page is scrolled by that distance before the frame is painted. (Marks picked on screen would not do:
       with only the empty tail in view they all lie inside the box, D12.) */
    function compensated(fn) {
      var b0 = box.getBoundingClientRect().bottom;
      fn();
      var d = box.getBoundingClientRect().bottom - b0;
      if (Math.abs(d) >= 1) window.scrollBy({ top: d, left: 0, behavior: 'instant' });
      if (window.umbraRebase) window.umbraRebase();
    }
    function onMove() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; reconcile(); });
    }
    function syncListeners() {
      var need = !!want && state !== 'natural';
      if (need && !listening) { listening = true; window.addEventListener('scroll', onMove, { passive: true }); window.addEventListener('resize', onMove, { passive: true }); }
      else if (!need && listening) { listening = false; window.removeEventListener('scroll', onMove); window.removeEventListener('resize', onMove); }
    }
    /* the one place the box changes size: only while its bottom edge is below the screen before and after the change (safeFor), so nothing on screen can move */
    function reconcile() {
      if (!want || state === 'natural') { syncListeners(); return; }
      if (want === state) { want = null; syncListeners(); return; }
      var how = safeFor(want);
      if (how) {
        var to = want; want = null;
        if (how === 'above') compensated(function () { setState(to); });
        else setState(to);
        if (to === 'natural') finish();
      } else if (want !== 'fixed') stopTicking();   // R15d: only this switch waits (no polling); scroll, resize and the end sentinel call reconcile
      syncListeners();
    }
    function request(to) {
      if (state === 'natural') return;
      if (to !== 'natural' && want === 'natural') return;
      want = (to === state) ? null : to;
      reconcile();
    }
    function finish() {
      removeSkel();
      stopTicking();
      /* the observer of the widget's tree stays (it only keeps the view steady once the box is natural, see followStep) */
      if (io) io.disconnect();
      if (nearIO) nearIO.unobserve(box);
      var i = boxes.indexOf(box); if (i >= 0) boxes.splice(i, 1);
      var g = hostGates.indexOf(gate); if (g >= 0) hostGates.splice(g, 1);
    }
    box.__umbraRvGo = function () { evaluate(true); };   // a refusal, or GONE_MS after the load event: look again (see "consent")

    function watchRoot() {
      if (root || !host.shadowRoot) return;
      root = host.shadowRoot;
      if ('MutationObserver' in window) {
        mo = new MutationObserver(function () {
          if (fRunning) followStep();   // the visitor is in or near the box: keep what is on screen where it was, in this same task
          if (state === 'natural') return;
          lastMut = Date.now();
          if (!evalTimer) evalTimer = setTimeout(function () { evalTimer = 0; evaluate(true); }, 100);
        });
        mo.observe(root, { childList: true, subtree: true });
      }
    }

    function evaluate(recount) {
      try {
        if (state === 'natural') return;
        if (!host.isConnected) { setState('natural'); finish(); return; }
        var now = Date.now();
        watchRoot();
        if (root && (recount || !nodes)) nodes = root.querySelectorAll(REVIEW_SEL).length;
        if (nodes > 0 && !firstNodeAt) firstNodeAt = now;

        /* no Bazaarvoice request has started: blocked (consent not given) or absent. The skeleton stays; the box gets the short size at the next
           moment it is out of view, BV_WAIT_MS after this script started (R3), later while bv.js we added is still on its way or the banner
           holds it. Refused with the loader really absent (see "consent"): the box goes. */
        if (!bvSeen) {
          if (refused() && loaderGone(now)) { request('natural'); return; }
          var waiting = early.injectedAt && !early.loadedAt && !early.failed && now - early.injectedAt < 15000;
          var held = early.timer && now - T0 < 20000 && !refused();   // the cookie banner has not answered yet (it starts late on a slow phone)
          if (state === 'fixed' && !waiting && !held && now - T0 >= BV_WAIT_MS) request('short');
          if (state === 'short' && !want) stopTicking();
          return;
        }
        /* Bazaarvoice has started (also later, when consent is given): back to the full size, unless the product has no reviews */
        if (!noRev && (nodes > 0 || !knownNoRev)) request('fixed');

        /* a product without reviews: no review node, no stars under the title, the widget has ended as a short invitation. R38: a product
           of the no-review list (html.umbra-norev) is trusted whatever the invitation's height (US 679 px, EU 629 px); the 400 px test
           is for the others */
        if (!nodes && root) {
          var h = contentHeight(host);
          var busy = bvInflight > 0 || now - bvLastEnd < 1500;
          if (h > 0 && (knownNoRev ? starsShown() !== true : h < 400 && starsShown() === false) && !busy) {
            if (!noRevSince) noRevSince = now;
            if (now - noRevSince >= NOREV_QUIET_MS) { noRev = true; request('natural'); return; }
          } else noRevSince = 0;
        }
        /* settled = the reveal: reviews exist and Bazaarvoice has been quiet for QUIET_MS; or the latest moment. The skeleton goes now
           (what was hidden under it shows, nothing moves); the box switches to natural height at the next moment that cannot move the page */
        var settled = (nodes > 0 && bvInflight === 0 && now - bvLastEnd >= QUIET_MS && now - lastMut >= QUIET_MS) ||
          (firstNodeAt && now - firstNodeAt >= NODES_MAX_MS) ||
          (!nodes && bvInflight === 0 && now - bvLastAct >= NODES_NEVER_MS);
        if (settled) { removeSkel(); request('natural'); }
      } catch (e) {
        try { removeSkel(); setState('natural'); finish(); } catch (e2) { /* nothing more to do */ }
      }
    }
    function startTicking() {
      if (timer || state === 'natural') return;
      timer = setInterval(function () { evaluate(false); }, 250);
    }
    function stopTicking() { if (timer) { clearInterval(timer); timer = 0; } }
    function gate() { startTicking(); evaluate(true); }
    hostGates.push(gate);

    /* the sentinel at the bottom edge of the box: wakes the check when the edge crosses the bottom of the screen */
    if ('IntersectionObserver' in window && end) {
      io = new IntersectionObserver(function () { if (want) reconcile(); });
      io.observe(end);
    }
    followHosts.push(followEntry);
    observeFollow(box, followEntry);
    boxes.push(box);
    if (nearIO) nearIO.observe(box);
    startTicking();
    evaluate(true);
  }

  function scan() {
    var found = document.querySelectorAll('.umbra-rv-box[data-umbra-rv-box]');
    for (var i = 0; i < found.length; i++) watchBox(found[i]);
  }

  function init() {
    window.umbraRvReady = true;
    /* the other start trigger: the box within two screens of the viewport */
    if ('IntersectionObserver' in window && !document.documentElement.classList.contains('umbra-norev')) {
      nearIO = new IntersectionObserver(function (list) {
        for (var i = 0; i < list.length; i++) if (list[i].isIntersecting) { earlyTrigger(); nearIO.disconnect(); nearIO = null; return; }
      }, { rootMargin: '200% 0px 200% 0px' });
    }
    scan();
    if (EARLY_AT_DCL && boxes.length && !document.documentElement.classList.contains('umbra-norev')) earlyTrigger();
    /* the box exists in the page source, but an app block can be added late */
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(scan);
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 30000);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
